// import React from "react";
// import MapIcon from "@material-ui/icons/Map";
// import ListIcon from "@material-ui/icons/List";
// import { PlateViewItem } from "../components/PlateViewItem";
// import { calculateDistance, getLatLon } from "../utils/logUtils";

// const SelectAllViewItem = ({ vehicle, isSelected, onToggle }) => (
//     <div onClick={() => onToggle(vehicle.id)} style={{ padding: "12px 15px", cursor: "pointer", backgroundColor: isSelected ? "#804600" : "#ffffff", color: isSelected ? "white" : "black", borderBottom: "1px solid #eee" }}>
//         <strong style={{ fontSize: "0.75em" }}>{vehicle.plate}</strong>
//         <div style={{ fontSize: "0.9em", opacity: 0.8 }}>
//             {vehicle.tag} {vehicle.brand}
//         </div>
//     </div>
// );

// const VehicleListPanel = ({ isListVisible, setListVisible, searchTerm, setSearchTerm, isSmall, isAllSelected, handleToggleAll, filteredVehicles, userLocation, locationError, handleToggleVehicle, selectedVehicleIds }) => {
//     const panelStyle = {
//         position: "absolute",
//         zIndex: 1000,
//         backgroundColor: "#EDEDED",
//         borderRadius: "8px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
//         top: "10px",
//         right: "10px",
//         bottom: isListVisible ? "10px" : "auto",
//         width: isListVisible ? (isSmall ? "calc(100% - 20px)" : "320px") : "auto",
//         left: isListVisible && isSmall ? "10px" : "auto",
//         height: "auto",
//         transition: "width 0.3s ease-in-out",
//     };

//     return (
//         <div style={panelStyle}>
//             <div style={{ display: "flex", alignItems: "top", justifyContent: "top" }}>
//                 {isListVisible && (
//                     <div style={{ flex: 1, margin: "10px 0px 10px 10px" }}>
//                         <input type="text" placeholder="Search by plate..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{ width: "100%", padding: "10px", borderRadius: "4px", border: "1px solid #ccc", boxSizing: "border-box" }} />
//                     </div>
//                 )}
//                 <button onClick={() => setListVisible(prev => !prev)} style={{ border: "none", background: "transparent", margin: "10px", cursor: "pointer", borderRadius: "4px" }}>
//                     {isListVisible ? <MapIcon /> : <ListIcon />}
//                 </button>
//             </div>

//             <div style={{ height: isListVisible ? "90%" : "0px", maxWidth: isListVisible ? "100%" : "0px", transition: "height maxWidth 0.3s ease-in-out", overflow: "hidden" }}>
//                 <div style={{ overflowY: "auto", height: "100%" }}>
//                     <SelectAllViewItem vehicle={{ id: "all", plate: "Show All Vehicles" }} isSelected={isAllSelected} onToggle={handleToggleAll} />

//                     {filteredVehicles.map(vehicle => {
//                         // Using the coordinate helper from your original file logic
//                         // const vLatLon = vehicle.lastLocation && vehicle.lastLocation.includes(",") ? { lat: parseFloat(vehicle.lastLocation.split(",")[0]), lon: parseFloat(vehicle.lastLocation.split(",")[1]) } : { lat: null, lon: null };
//                         // calculateDistance(userLocation, vLatLon);

//                         const distanceInKm = calculateDistance(userLocation, getLatLon(vehicle.lastLocation));
//                         // const distanceInKm = calculateDistance(userLocation, vLatLon);

//                         return (
//                             <PlateViewItem
//                                 key={vehicle.id}
//                                 vehicle={{
//                                     ...vehicle,
//                                     distance: locationError || distanceInKm,
//                                 }}
//                                 onToggle={handleToggleVehicle}
//                                 isSelected={!isAllSelected && selectedVehicleIds.includes(vehicle.id)}
//                             />
//                         );
//                     })}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export { VehicleListPanel };
import React from "react";
import MapIcon from "@material-ui/icons/Map";
import ListIcon from "@material-ui/icons/List";
import { PlateViewItem } from "../components/PlateViewItem";
import { calculateDistance, getLatLon } from "../utils/logUtils";

// const SelectAllViewItem = ({ vehicle, isSelected, onToggle }) => (
//     <div
//         onClick={() => onToggle(vehicle.id)}
//         style={{
//             padding: "12px 16px",
//             cursor: "pointer",
//             backgroundColor: isSelected ? "#34495e" : "transparent",
//             color: isSelected ? "white" : "#2c3e50",
//             borderBottom: "1px solid rgba(0,0,0,0.05)",
//             transition: "background 0.2s ease",
//         }}
//     >
//         <strong style={{ fontSize: "14px", display: "block" }}>{vehicle.plate}</strong>
//         <div style={{ fontSize: "12px", opacity: 0.8, marginTop: "2px" }}>
//             {vehicle.tag} {vehicle.brand}
//         </div>
//     </div>
// );

const SelectAllViewItem = ({ isSelected, onToggle }) => {
    const styles = {
        container: {
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
            cursor: "pointer",
            borderBottom: "1px solid rgba(0,0,0,0.05)",
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            transition: "background-color 0.15s ease",
        },
        text: {
            fontSize: "14px",
            fontWeight: "700",
            marginRight: "12px",
            color: isSelected ? "#1e293b" : "#64748b",
            letterSpacing: "0.3px",
        },
        switch: {
            width: "36px",
            height: "20px",
            borderRadius: "12px",
            backgroundColor: isSelected ? "#2563eb" : "#94a3b8",
            position: "relative",
            transition: "all 0.2s ease",
        },
        knob: {
            width: "14px",
            height: "14px",
            backgroundColor: "#ffffff",
            borderRadius: "50%",
            position: "absolute",
            top: "3px",
            left: isSelected ? "19px" : "3px",
            transition: "left 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        },
    };

    return (
        <div style={styles.container} onClick={() => onToggle("all")}>
            <div style={styles.text}>View All</div>
            <div style={styles.switch}>
                <div style={styles.knob} />
            </div>
        </div>
    );
};

const VehicleListPanel = ({ isListVisible, setListVisible, searchTerm, setSearchTerm, isSmall, isAllSelected, handleToggleAll, filteredVehicles, userLocation, locationError, handleToggleVehicle, selectedVehicleIds }) => {
    const panelStyle = {
        position: "absolute",
        zIndex: 1000,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        borderRadius: "10px",
        boxShadow: "0 8px 32px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.05)",
        top: "10px",
        right: "10px",
        bottom: isListVisible ? "10px" : "auto",
        width: isListVisible ? (isSmall ? "calc(100% - 20px)" : "340px") : "48px",
        maxHeight: "85vh",
        // left: isListVisible && isSmall ? "10px" : "auto",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    };

    return (
        <div style={panelStyle}>
            <div style={{ display: "flex", alignItems: "center", padding: isListVisible ? "8px" : "0px" }}>
                {isListVisible && (
                    <div style={{ flex: 1, marginRight: "8px" }}>
                        <input
                            type="text"
                            placeholder="Search by plate..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                width: "100%",
                                height: "40px",
                                padding: "0 12px",
                                borderRadius: "8px",
                                border: "1px solid rgba(0,0,0,0.1)",
                                boxSizing: "border-box",
                                fontSize: "14px",
                                outline: "none",
                                backgroundColor: "rgba(255,255,255,0.5)",
                            }}
                        />
                    </div>
                )}
                <button
                    onClick={() => setListVisible(prev => !prev)}
                    style={{
                        border: "none",
                        background: isListVisible ? "transparent" : "rgba(255, 255, 255, 0.9)",
                        // color: isListVisible ? "inherit" : "white",
                        minWidth: "48px",
                        height: "48px",
                        cursor: "pointer",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s",
                    }}
                >
                    {isListVisible ? <MapIcon /> : <ListIcon />}
                </button>
            </div>

            {isListVisible && (
                <div style={{ flex: 1, overflowY: "auto", borderTop: "1px solid rgba(0,0,0,0.05)", left: "0px" }}>
                    <SelectAllViewItem vehicle={{ id: "all", plate: "Show All Vehicles" }} isSelected={isAllSelected} onToggle={handleToggleAll} />

                    {filteredVehicles.map(vehicle => {
                        const distanceInKm = calculateDistance(userLocation, getLatLon(vehicle.lastLocation));

                        return (
                            <PlateViewItem
                                key={vehicle.id}
                                vehicle={{
                                    ...vehicle,
                                    distance: locationError || distanceInKm,
                                }}
                                onToggle={handleToggleVehicle}
                                isAllSelected={isAllSelected}
                                isAllSelected={isAllSelected}
                                isSelected={selectedVehicleIds.includes(vehicle.id)}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export { VehicleListPanel };
